const toViewClass = (name, viewEnabled) => viewEnabled && `view-${name}`;
export {
  toViewClass
};
//# sourceMappingURL=toViewClass.js.map
